"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldChange = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.FieldChange = typebox_1.Type.Object({
    field: typebox_1.Type.String(),
    oldValue: typebox_1.Type.Optional(typebox_1.Type.String()),
    newValue: typebox_1.Type.String(),
});
//# sourceMappingURL=field-change.js.map